import SystemDivider from "@mui/material/Divider";
import { styled } from "../../styles/index.js";
import { rootShouldForwardProp } from "@mui/material/styles/styled";
const DividerRoot = styled(SystemDivider, {
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
  name: "TrueDivider",
  slot: "Root"
})(({ weight = "thin", theme }) => {
  if (weight === "bold") {
    return {
      borderBottomWidth: "8px",
      borderColor: theme.palette?.tertiary?.main
    };
  }
  return null;
});
export {
  DividerRoot
};
//# sourceMappingURL=divider.styles.js.map
